import React from 'react';
import { Card, CardContent, PageLayout } from '../../../../components/shared';
import { useLanguage } from '../../../../hooks/shared';
import { useHomeCalendarMode } from '../../hooks';
import {
  CalendarView as CalendarViewType,
  DaySchedule,
} from '../../types/calendarTypes';
import Calendar from '../Calendar';

interface CalendarViewProps {
  isDayDetail: boolean;
  schedules: DaySchedule[];
  scheduleStore: any;
  calendarView: CalendarViewType;
  calendarCurrentDate: Date;
  navigationHandlers: {
    handleDateSelect: (date: Date) => void;
    handleTimeSlotClick: (date: string, trainingId: string) => void;
    handleCalendarViewChange: (view: CalendarViewType) => void;
    handleCalendarDateChange: (date: Date) => void;
  };
}

/**
 * Smart component for calendar view mode (week/month)
 */
export const CalendarView: React.FC<CalendarViewProps> = ({
  isDayDetail,
  schedules,
  scheduleStore,
  calendarView,
  calendarCurrentDate,
  navigationHandlers,
}) => {
  const { t } = useLanguage();

  // Use calendar mode hook internally
  const calendarData = useHomeCalendarMode(
    isDayDetail,
    calendarCurrentDate,
    scheduleStore
  );

  // If in day detail mode, don't render calendar view
  if (isDayDetail || !calendarData) {
    return null;
  }

  const { currentSchedule } = calendarData;

  return (
    <PageLayout
      title={t('calendar.schedule')}
      subtitle={currentSchedule?.name || scheduleStore.currentSchedule?.name}
      icon="📅"
    >
      <Card className="shadow-xl">
        <CardContent className="p-6">
          <Calendar
            schedules={schedules}
            onDateSelect={navigationHandlers.handleDateSelect}
            onTimeSlotClick={navigationHandlers.handleTimeSlotClick}
            selectedDate={null}
            selectedTimeSlotId={undefined}
            onCalendarViewChange={navigationHandlers.handleCalendarViewChange}
            currentView={calendarView}
            currentDate={calendarCurrentDate}
            onCurrentDateChange={navigationHandlers.handleCalendarDateChange}
          />
        </CardContent>
      </Card>
    </PageLayout>
  );
};
